interface IBanner {
	color: string,
	bgColor: string,
}
export interface IHit {
  title: string;
	preamble: string;
  id: string;
	url: string;
	type: string;
  path: string;
  bannerText: string;
  bannerColor: IBanner;
}

export interface IType {
  title: string,
  name: string,
  options: ITypeOption[]
}
export interface ITagOption {
  name: string;
  title: string;
  selected: boolean;
}

export interface ITypeOption extends ITagOption {
}
export interface ITag {
  name: string;
  title: string;
  options: ITagOption[];
}

export interface ISelectedFilter {
  title: string,
	name: string,
	option: ITagOption,
}
export interface IState {
  query: string;
  url: string;
  total: number;
  hits: IHit[];
  loading: boolean;
  numberToShow: number;
  initialNumberToShow: number;
  suggestion: string;
  tags: ITag[];
  filters: ITag[];
  selectedTypes: string;
  selectedFilters: ISelectedFilter[];
  typeFilters: ITagOption[];
}

const deafultState: IState = {
  query: '',
  url: '',
  total: 0,
  hits: [],
  loading: false,
  numberToShow: 0,
  initialNumberToShow: 0,
  suggestion: '',
  tags: [],
  filters: [],
  selectedTypes: '',
  selectedFilters: [],
  typeFilters: [],
}

export default deafultState;
